import React, { useEffect, useMemo, useRef, useState } from "react";
import "./styles.css";
import { AutoComplete, Breadcrumb, DatePickerInput, SuccessPopupModal, TextInput, Title, } from "../../Components/Atoms";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button, useToast } from "@chakra-ui/react";
import { getStatesByCountryId, getCitiesByStateID, editDealershipDetails, getAllMakes } from "../../APIs";
import PATH from "../../Routes/paths";
import { isValidMobile, isValidEmail, isValidPincode} from "../../Library/validations";
import ROUTES from "../../Routes/paths";

const FIELD_TYPE = {
  LABEL: 1,
  TEXT: 2,
  AUTOCOMPLETE: 3,
  DATEPICKER: 4,
};

const EditDealership = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialState = {
    nm: location.state.dealerDetails.nm || "",
    mob: location.state.dealerDetails.mob || "",
    amob: location.state.dealerDetails.amob || "",
    eml: location.state.dealerDetails.eml || "",
    gstno: location.state.dealerDetails.gstno || "",
    pin: location.state.dealerDetails.pin || "",
    cNm: location.state.dealerDetails.cNm || "",
    ct: location.state.dealerDetails.ct || "",
    sNm: location.state.dealerDetails.sNm || "",
    st: location.state.dealerDetails.st || "",
    vmk: location.state.dealerDetails.vmk || "",
    mk: location.state.dealerDetails.mk || "",
    add: location.state.dealerDetails.add || "",
    dnm: location.state.dealerDetails.dnm || "",
    dmob: location.state.dealerDetails.dmob || "",
    deml: location.state.dealerDetails.eml || "",
    ddes: location.state.dealerDetails.ddes || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [oemOptions, setOemOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const formRef = useRef("");
  const Toast = useToast();
  const [ searchParams ] = useSearchParams();
  const [editedValues, setEditedValues] = useState({ idx: Number(searchParams.get("idx")) });

  useEffect(() => {
    getStatesByCountryId()
      .then((data) => {
        if (data.length) {
          let options = [];
          data.sort((a, b) => a.nm.localeCompare(b.nm));
          data.forEach((state) => {
            if (state.nm && state.idx)
              options.push({ label: state.nm, value: state.idx });
          });
          setStateOptions(options);
        }
      })
      .catch((err) => console.error("EditDealership fetch states failed.", err));

      getAllMakes((err,data)=>{
        if(err){
          console.error("EditDealership fetch oems failed.", err);
        }
        else if (data.length){
          let options = [];
          data.sort((a, b) => a.nm.localeCompare(b.nm));
          data.forEach(oem => {
            if (oem.nm && oem.idx)
              options.push({ label: oem.nm, value: oem.idx });
          });
          setOemOptions(options);
        }
      })
  }, []);

  const fetchCities = (stateId) => {
    getCitiesByStateID(stateId)
    .then((data) => {
        if (data.length) {
        let options = [];
        data.sort((a, b) => a.nm.localeCompare(b.nm));
        data.forEach((state) => {
            if (state.nm && state.idx)
            options.push({ label: state.nm, value: state.idx });
        });
        setCityOptions(options);
        }
    })
    .catch((err) => console.error("AddClient fetch states failed.", err));
  }

  const editDealershipFormFields = useMemo(
    () => [
      {
        type: FIELD_TYPE.TEXT,
        label: "Dealership Name",
        name: "nm",
        placeholder: "Enter Dealership Name",
        required: true,
        cls: "add-client-halfw",
      },
      {
        type: FIELD_TYPE.AUTOCOMPLETE,
        label: "OEM",
        name: "mk",
        placeholder: "Select OEM",
        required: true,
        cls: "add-client-halfw",
        options: oemOptions,
        onChange: (oemId, oemObj) => {
          setFormFieldData('vmk')(oemObj.label);
          setFormFieldData('mk')(oemObj.value);
        }
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Mobile Number",
        name: "mob",
        cls: "edit-client-halfw",
        placeholder: "Enter Mobile Number",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Alternate  Number",
        name: "amob",
        cls: "edit-client-halfw",
        placeholder: "Enter Alternate Mobile Number",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Email Address",
        name: "eml",
        placeholder: "Enter Email Address",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "GST Number",
        name: "gstno",
        placeholder: "Enter GST Number",
      },
      {
        type: FIELD_TYPE.AUTOCOMPLETE,
        label: "State",
        name: "st",
        placeholder: "Select State",
        cls: "edit-client-halfw",
        options: stateOptions,
        onChange: (stateId, stateObj) => {

          if (formData.st === stateId)
            return;
          setFormFieldData('sNm')(stateObj.label);
          setFormFieldData('st')(stateObj.value);
          setFormFieldData('ct')("");
          setFormFieldData('cNm')("");
          getCitiesByStateID(stateId).then((data) => {
            if (data.length) {
              let options = [];
              data.sort((a, b) => a.nm.localeCompare(b.nm));
              data.forEach(state => {
                if (state.nm && state.idx)
                  options.push({ label: state.nm, value: state.idx });
              });
              setCityOptions(options);
            }
          })
            .catch((err) => console.error("Edit Dealer fetch states failed.", err))
        },
        required: true,
      },
      {
        type: FIELD_TYPE.AUTOCOMPLETE,
        label: "City",
        name: "ct",
        placeholder: "Select City",
        cls: "edit-client-halfw",
        options: cityOptions,
        required: true,
        onChange: (_, cityObj) => {
          setFormFieldData('ct')(cityObj.value);
          setFormFieldData('cNm')(cityObj.label);
        },
       },
      {
        type: FIELD_TYPE.TEXT,
        label: "Pincode",
        name: "pin",
        placeholder: "Enter Pincode",
        regex: /^[1-9][0-9]{5}$/,
        cls: "edit-client-halfw",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Address",
        name: "add",
        placeholder: "Enter Address",
        required: true,
      },
      {
        type: FIELD_TYPE.LABEL,
        label: "Contact Person Details",
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Name",
        name: "dnm",
        placeholder: "Enter Name",
        cls: "edit-client-halfw",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Mobile Number",
        name: "dmob",
        placeholder: "Enter Mobile Number",
        cls: "edit-client-halfw",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Email Address",
        name: "deml",
        placeholder: "Enter Email Address",
        required: true,
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Designation",
        name: "ddes",
        placeholder: "Enter Designation",
        required: true,
      },
    ],
    [oemOptions, stateOptions, cityOptions, formData.st]
  );

  const setFormFieldData = (key) => (value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setEditedValues((prev) => ({ ...prev, [key]: value }));
  };

  const saveDealershipData = (modelData) => {
    let postFunction = editDealershipDetails;

    postFunction(modelData, (failure, success) => {
      if (failure) {
        const errMsg = JSON.parse(failure).data;
        Toast({
          isClosable: true,
          description: errMsg,
          position: "bottom",
          variant: "subtle",
          duration: 3000,
        });
      } else {
        setFormData(initialState);
        setIsOpen(true);
      }
    });
  };

  const submitHandler = () => {
    if(Object.keys(editedValues).length === 1){
      Toast({
        isClosable: true,
        description: "No Changes made to save !!",
        position: "bottom",
        variant: "subtle",
        duration: 3000,
      });
      return;
    }

    let errors = {};
    let hasError = false;

    if (editedValues.mob || editedValues.amob || editedValues.dmob) {
        if (!isValidMobile(editedValues.mob || editedValues.amob || editedValues.dmob)) {
            hasError = true;
            errors[(editedValues.mob && "mob") || (editedValues.amob && "amob") || (editedValues.dmob && "dmob")] = "Please enter valid mobile";
        }
    }

    if (editedValues.eml || editedValues.deml) {
       if (!isValidEmail(editedValues.eml || editedValues.deml) ) {
            hasError = true;
            errors[(editedValues.eml && "eml") || (editedValues.deml && "deml")] = "Please enter valid email";
       }
    }

    if(editedValues.state && !editedValues.city){
        hasError = true;
        errors.city = "Please select city";
    }

    if (editedValues.pin) {
      if (!isValidPincode(editedValues.pin)) {
        hasError = true;
        errors.pin = "Please enter valid pincode";
      }
    }

    Object.keys(editedValues).forEach((key) => {
    if (key !== "amob" && key !== "gstno") {
      if (!editedValues[key]) {
        hasError = true;
        errors[key] = "This field is required";
      }
    } else {
      const isFieldInitiallyPresent = location.state.dealerDetails[key];
      const isFieldEmpty = editedValues[key] === "";
      if (isFieldInitiallyPresent && isFieldEmpty) {
        hasError = true;
        errors[key] = "This field cannot be left blank";
      } else if (!isFieldInitiallyPresent && isFieldEmpty) {
        delete editedValues[key];
      }
    }
    });

    if (hasError) setFormErrors(errors);
    else if (Object.values(editedValues).length > 1) saveDealershipData(editedValues);
  };

  const dealerShipBreadcrumbPaths = [
    { idx: 1, name: "Dealership Details", link: `${PATH.SHOW_DEALERS}/${PATH.SPECIFIC_DEALER}?idx=${location.state.dealerDetails.idx}` },
    { idx: 2, name: "Edit Dealership", link: "", isCurrentPage: true },
  ];

  const handleFetchCities = (name) => {
    if (!cityOptions.length) fetchCities(formData[name]);
    return formData[name];
  }

  return (
    <section className="panel-main">
      <div>
        <Breadcrumb paths={dealerShipBreadcrumbPaths} />
      </div>

      <div className="edit-client">
        <Title>Edit Dealership</Title>
        <form className="edit-client-form" ref={formRef}>
          {editDealershipFormFields.map((formField, idx) => {
            return (
              <div
                key={idx}
                className={formField.cls ? formField.cls : "edit-client-fullw"}
              >
                {formField.type === FIELD_TYPE.LABEL && (
                  <p key={idx} className="edit-client-subheadings">
                    {formField.label || ""}
                  </p>
                )}
                {formField.type === FIELD_TYPE.TEXT && (
                  <TextInput
                    inputName={formField.name || ""}
                    placeholder={formField.placeholder}
                    className="edit-client-text-field"
                    label={formField.label}
                    labelClassName="edit-client-text-field-label "
                    errMessage={formErrors[formField.name] || ""}
                    rightElement={formField.rightText}
                    inputCover={formField.cls ? "custom-cover-w" : ""}
                    onChange={
                      formField.onChange || setFormFieldData(formField.name)
                    }
                    value={formData[formField.name]}
                    isRequired={formField.required}
                  />
                )}
                {formField.type === FIELD_TYPE.AUTOCOMPLETE && (
                  <AutoComplete
                    options={
                      formField.options || [
                        { label: "bhopal", value: "bhopal" },
                      ]
                    }
                    label={formField.label}
                    autoCompleteClassName={"edit-client-autocomplete"}
                    className={"edit-client-autocomplete-field"}
                    labelClassName={"edit-client-autocomplete-field-label"}
                    placeholder={formField.placeholder}
                    errMessage={formErrors[formField.name] || ""}
                    inputName={formField.name}
                    onChange={
                      formField.onChange || setFormFieldData(formField.name)
                    }
                    inputCover={formField.cls ? "custom-cover-w" : ""}
                    value={formField.name === "st" ? handleFetchCities(formField.name) : formData[formField.name]}
                    isRequired={formField.required}
                  />
                )}
                {formField.type === FIELD_TYPE.DATEPICKER && (
                  <DatePickerInput
                    inputName={formField.name || ""}
                    className="edit-client-datepicker-field"
                    label={formField.label}
                    labelClassName="edit-client-datepicker-field-label"
                    DatepickerClassName="edit-client-datepicker"
                    errMessage={formErrors[formField.name] || ""}
                    inputCover={formField.cls ? "custom-cover-w" : ""}
                    onChange={
                      formField.onChange || setFormFieldData(formField.name)
                    }
                    value={formData[formField.name]}
                    isRequired={formField.required}
                  />
                )}
              </div>
            );
          })}
          <div className="add-battery-submit-button">
            <Button className="add-battery-button" onClick={submitHandler}>
              Save
            </Button>
          </div>
        </form>
      </div>

      <SuccessPopupModal
        open={isOpen}
        modalMsg={"Dealership Edited successfully"}
        closeBtn={"Okay"}
        modalSize={"lg"}
        onModalClose={() => navigate(`${ROUTES.SHOW_DEALERS}/${ROUTES.SPECIFIC_DEALER}?idx=${searchParams.get("idx")}`)}
      />
    </section>
  );
};

export default EditDealership;
